/**
 * 레거시 useAnnouncements.compressImage 포팅.
 * maxWidth 유지 비율 축소 후 JPEG/원본 타입 quality로 Blob→File.
 */
export const compressImage = (
  file: File,
  maxWidth = 1200,
  quality = 0.8,
): Promise<File> =>
  new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      reject(new Error('Canvas를 사용할 수 없습니다.'));
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      let { width, height } = img;

      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('이미지 압축에 실패했습니다.'));
            return;
          }
          resolve(
            new File([blob], file.name, {
              type: file.type || blob.type,
              lastModified: Date.now(),
            }),
          );
        },
        file.type || 'image/jpeg',
        quality,
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('이미지를 불러오지 못했습니다.'));
    };

    img.src = objectUrl;
  });
